import React, { useEffect, useState } from 'react';
import Card from '../../components/ui/Card';
import Btn from '../../components/ui/Btn';
import Badge from '../../components/ui/Badge';
import { Input, Select } from '../../components/ui/Input';
import { regioesEntregaApi } from '../../api/regioesEntrega';
import { COLORS } from '../../theme';
import { useTituloPagina } from '../../context/PageTitleContext';

const UFS = [
  'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB',
  'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'
].map(uf => ({ value: uf, label: uf }));

const FORM_VAZIO = { nome: '', uf: 'MG', cidades: '', prazo_entrega_dias: '' };

export default function RegioesEntregaList() {
  useTituloPagina('Regiões de Entrega');
  const [regioes, setRegioes] = useState([]);
  const [editandoId, setEditandoId] = useState(null);
  const [form, setForm] = useState(FORM_VAZIO);
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');

  const carregar = () => regioesEntregaApi.listar().then(setRegioes).catch(() => {});
  useEffect(() => { carregar(); }, []);

  const onChange = (campo, valor) => setForm(f => ({ ...f, [campo]: valor }));

  const abrirNova = () => { setForm(FORM_VAZIO); setErro(''); setEditandoId('novo'); };
  const abrirEdicao = (r) => {
    setForm({ nome: r.nome, uf: r.uf, cidades: r.cidades || '', prazo_entrega_dias: String(r.prazo_entrega_dias) });
    setErro('');
    setEditandoId(r.id);
  };

  const salvar = async (e) => {
    e.preventDefault();
    if (!form.nome || !form.uf || !form.prazo_entrega_dias) { setErro('Preencha nome, UF e prazo de entrega'); return; }
    setSalvando(true);
    setErro('');
    try {
      if (editandoId === 'novo') await regioesEntregaApi.criar(form);
      else await regioesEntregaApi.atualizar(editandoId, form);
      setEditandoId(null);
      carregar();
    } catch (err) {
      setErro(err.message);
    } finally {
      setSalvando(false);
    }
  };

  const excluir = async (r) => {
    if (!window.confirm(`Excluir a região "${r.nome}"?`)) return;
    await regioesEntregaApi.excluir(r.id);
    carregar();
  };

  return (
    <div>
      <Card>
        <p style={{ fontSize: 13, color: COLORS.textMid, marginTop: 0 }}>
          Cadastre regiões por UF (e opcionalmente cidades específicas) com o prazo de entrega padrão de cada uma.
          Ao criar uma proposta, o sistema usa o endereço do cliente pra sugerir automaticamente o prazo — sempre dá pra alterar manualmente na proposta.
          Uma região sem cidades cadastradas serve como padrão pra toda a UF.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 16 }}>
          {regioes.map(r => (
            <div key={r.id} style={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              border: `1px solid ${COLORS.border}`, borderRadius: 10, padding: '10px 14px'
            }}>
              <div>
                <div style={{ fontWeight: 600, fontSize: 14 }}>{r.nome} <Badge tom="info">{r.uf}</Badge></div>
                <div style={{ fontSize: 12, color: COLORS.textMid }}>
                  {r.cidades ? `Cidades: ${r.cidades}` : 'Toda a UF (região padrão)'} · Prazo: {r.prazo_entrega_dias} dia{r.prazo_entrega_dias === 1 ? '' : 's'}
                </div>
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <Btn tamanho="sm" variante="ghost" onClick={() => abrirEdicao(r)}>Editar</Btn>
                <Btn tamanho="sm" variante="danger" onClick={() => excluir(r)}>Excluir</Btn>
              </div>
            </div>
          ))}
          {regioes.length === 0 && <p style={{ color: COLORS.textMid, fontSize: 13 }}>Nenhuma região cadastrada.</p>}
        </div>

        {editandoId ? (
          <form onSubmit={salvar} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, borderTop: `1px solid ${COLORS.border}`, paddingTop: 16 }}>
            <strong style={{ gridColumn: '1 / -1', fontSize: 13 }}>{editandoId === 'novo' ? 'Nova região' : 'Editando região'}</strong>
            <Input label="Nome da Região" value={form.nome} onChange={e => onChange('nome', e.target.value)} placeholder="Ex: Grande BH" required />
            <Select label="UF" options={UFS} value={form.uf} onChange={e => onChange('uf', e.target.value)} />
            <Input label="Cidades (separadas por vírgula, deixe em branco para toda a UF)" value={form.cidades} onChange={e => onChange('cidades', e.target.value)}
              placeholder="Ex: Belo Horizonte, Contagem, Betim" style={{ gridColumn: '1 / -1' }} />
            <Input label="Prazo de Entrega (dias)" type="number" min="0" value={form.prazo_entrega_dias} onChange={e => onChange('prazo_entrega_dias', e.target.value)} required />
            {erro && <p style={{ gridColumn: '1 / -1', color: COLORS.danger, fontSize: 13, margin: 0 }}>{erro}</p>}
            <div style={{ gridColumn: '1 / -1', display: 'flex', gap: 10 }}>
              <Btn variante="ghost" onClick={() => setEditandoId(null)} type="button">Cancelar</Btn>
              <Btn type="submit" disabled={salvando}>{salvando ? 'Salvando...' : 'Salvar Região'}</Btn>
            </div>
          </form>
        ) : (
          <Btn variante="secondary" onClick={abrirNova}>+ Nova Região de Entrega</Btn>
        )}
      </Card>
    </div>
  );
}
